import "./style.css";
import { Main } from "./Ui/Main.js";

new Main();